import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Card, CardHeader, CardBody, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Row, Col } from 'reactstrap';
import SweetAlert from 'sweetalert2';
import DataTable from 'react-data-table-component';
import { H3, Btn, Breadcrumbs } from '../../../AbstractElements';
import { Link, useNavigate } from 'react-router-dom';
import {  getDataWithToken } from '../../../Utils/restUtils';
import { Add, Customer, CustomerList, changepwd, Search, Filter, Area, Status, Export, Import, importFile, customerImportTitle, customerImportTableTitle, customerDueImportTitle, AddCustomer, AddServiceAccount, Enquiry, EnquiryList, newEnquiry, FollowUp, overDueFollowUps, followUpsList, overDueFollowUpsList } from '../../../Constant';
import { deleteCustomer, viewCustomer, viewCustomerRole, getArea, getstatscount, changecutomerstatus, publicSampleDownloadCustomer, getstatscountRole, getAreaRole, changecutomerstatusRole, deleteCustomerRole, publicSampleDownloadCustomerDue, postCustomerImportDue, showEnquiry, showEnquiryRole, enquirystatusCount, enquirystatusCountRole, showFollowUp, showFollowUpRole, getAllOverdues, getAllOverduesRole, getUsers, getUsersRole, getStaff } from '../../../CommonURL';
import { useSelector } from 'react-redux';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from "jspdf-autotable";
import Popup from '../../Common/Popup/Popup';
// import ChangePwd from './ChangePwd';
import DatePicker from 'react-datepicker';
import { toast } from 'react-toastify';
import moment from 'moment';;
import Transparentspinner from '../../Common/loader/Transparentspinner';
import { CustomerColumns, duefollowUpColumns, followUpColumns } from '../CloumnHeader/Header';


const OverdueFollowUp = () => {

  const searchParams = location.search;
  const params = new URLSearchParams(searchParams);
  const [spinnerTrans, setspinnerTrans] = useState(false);
  const [customerLists, setCustomerList] = useState([]);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [users, setUsers] = useState([]);
  const [tempUser, setTempUser] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [userData, setUserData] = useState([]);
  const [filters, setFilters] = useState({
    search: params.get('search') || '',
    start_date: params.get('start_date') ? moment(params.get('start_date'), "DD-MM-YYYY").toDate() : '',
    end_date: params.get('end_date') ? moment(params.get('end_date'), "DD-MM-YYYY").toDate() : '',
    userId: params.get("user") || '',
    stage: params.get("stage") || '',
  });
  const [dateRange, setDateRange] = useState([filters.start_date, filters.end_date]);
  const [startDate, endDate] = dateRange
  const [sortConfig, setSortConfig] = useState({ column: '', order: '' });


  const formatStartDate = filters.start_date ? moment(filters.start_date).format("DD-MM-YYYY") : '';
  const formatEndDate = filters.end_date ? moment(filters.end_date).format("DD-MM-YYYY") : '';

  const authState = useSelector((state) => state.auth);

  const navigate = useNavigate();


  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const toggleStyle = { padding: '10px 20px', opacity: '0.8', fontSize: '14px' }

  const enquiryStatusOptions = [
    { label: 'Prospect', value: 'prospect' },
    { label: 'Negotiation', value: 'negotiation' },
    { label: 'Won', value: 'won' },
    { label: 'Lost', value: 'lost' },
  ];

  useEffect(() => {
    fetchFollowUps(1);
    getuserData()
  }, []);




  const handleApiError = (status) => {
    if (status >= 400 && status <= 405) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
    } else if (status >= 500 && status <= 505) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
    } else {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
    }
  };

  const handleSort = (column) => {
    let newOrder = 'asc';
    if (sortConfig.column === column.id) {
      newOrder = sortConfig.order === 'asc' ? 'desc' : 'asc';
    }
    setSortConfig({ column: column.id, order: newOrder });
    fetchFollowUps(currentPage, perPage, filters.searchKey, filters.start_date, filters.end_date, filters.areaFilter, filters.cust_status_Filter, column.id, newOrder);
  };

//   //user data

  const getuserData = async () => {
    const data = await getDataWithToken(getStaff);

    if (data.status === true) {
      setUsers(data.data.data);
    }
  };

  const fetchFollowUps = async (page, size = perPage, searchKey = '', start_date = '', end_date = '', areaFilter = '', cust_status_Filter = '', sortBy = '', sortOrder = '') => {
    setspinnerTrans(true)
    const response = await getDataWithToken(getAllOverdues +
      `?page=${page}&page_length=${size}&search=${filters.search}&start_date=${formatStartDate}&end_date=${formatEndDate}&stage=${filters.stage}&user_id=${filters.userId}&sort_by=${sortBy}&sort_order=${sortOrder}` 
     );
    if (response?.status === true) {
      setResetPaginationToggle(!resetPaginationToggle);
      const SerialNo = (page - 1) * size + 1;
      setCustomerList(response?.data?.data.map((e, index) => {
        return {
          Si: SerialNo + index,
          name: e.name || 'N/A',
          leadId: e?.lead_id,
          remarks: e.remarks,
          assigned: e?.assigned_to,
          nextFolloWDate: e?.next_followup_date,
          id: e?.id,
          stage: e?.stage

        }
      }))
      setTotalRows(response.data.total);
    } else {
      handleApiError(response.status);
    }
    setspinnerTrans(false)
  };
const exportCustomerExcel = async () => {
  setspinnerTrans(true);

  try {
    const response = await getDataWithToken(
      `${getAllOverdues}?page=1
      &page_length=10000
      &search=${filters.search || ""}
      &start_date=${formatStartDate || ""}
      &end_date=${formatEndDate || ""}
      &stage=${filters.stage || ""}
      &user_id=${filters.userId || ""}
      &sort_by=${sortConfig.column || ""}
      &sort_order=${sortConfig.order || ""}`
    );

    if (response?.status === true) {
      const dataToExport = response.data.data.map((item) => ({
        Lead_ID: item.lead_id || "",
        Name: item.name || "",
        Assigned_To: item.assigned_to || "",
        Remarks: item.remarks || "",
        Next_Followup_Date: item.next_followup_date || "",
        Stage: item.stage || "",
      }));

      const ws = XLSX.utils.json_to_sheet(dataToExport);
      const wb = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, ws, "Overdue Followups");
      XLSX.writeFile(wb, "overdue_followups.xlsx");
    }
  } catch (error) {
    console.log("Excel Export Error:", error);
    toast.error("Failed to export Excel");
  } finally {
    setspinnerTrans(false);
  }
};
const exportCustomerPdf = async () => {
  setspinnerTrans(true);

  try {
    const response = await getDataWithToken(
      `${getAllOverdues}?page=1
      &page_length=10000
      &search=${filters.search || ""}
      &start_date=${formatStartDate || ""}
      &end_date=${formatEndDate || ""}
      &stage=${filters.stage || ""}
      &user_id=${filters.userId || ""}
      &sort_by=${sortConfig.column || ""}
      &sort_order=${sortConfig.order || ""}`
    );

    if (response?.status === true) {
      const rows = response.data.data.map((item, index) => [
        index + 1,
        item.lead_id || "",
        item.name || "",
        item.assigned_to || "",
        item.remarks || "",
        item.next_followup_date || "",
        item.stage || "",
      ]);

      const doc = new jsPDF("landscape");

      doc.setFontSize(16);
      doc.text("Overdue Follow Up Report", 14, 15);

      autoTable(doc, {
        startY: 25,
        head: [[
          "Sl",
          "Lead ID",
          "Name",
          "Assigned To",
          "Remarks",
          "Next Followup Date",
          "Stage",
        ]],
        body: rows,
        styles: {
          fontSize: 8,
        },
        headStyles: {
          fillColor: [41, 128, 185],
        },
      });

      doc.save("overdue_followups.pdf");
    }
  } catch (error) {
    console.log("PDF Export Error:", error);
    toast.error("Failed to export PDF");
  } finally {
    setspinnerTrans(false);
  }
};
  const handlePageChange = page => {
    fetchFollowUps(page, perPage, filters.search, filters.start_date, filters.end_date, filters.areaFilter, filters.cust_status_Filter, sortConfig.column, sortConfig.order);
    setCurrentPage(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    fetchFollowUps(page, newPerPage, filters.search, filters.start_date, filters.end_date, filters.areaFilter, filters.cust_status_Filter, sortConfig.column, sortConfig.order);
    setPerPage(newPerPage);
  };

  const handleFilter = async (e) => {
    e.preventDefault();
    const start_date = startDate ? moment(startDate).format("DD-MM-YYYY") : '';
    const end_date = endDate ? moment(endDate).format("DD-MM-YYYY") : '';
    const queryParams = new URLSearchParams({
      search: filters.search,
      start_date,
      end_date,
      user: filters?.userId,
      stage: filters?.stage,
      sortBy: sortConfig.column || '',
      sortOrder: sortConfig.order || '',
    }).toString();
    navigate(`/lead-manage/overdue-follow-ups?${queryParams}`);
    fetchFollowUps(currentPage, perPage, start_date, end_date, sortConfig.column, sortConfig.order);
  };



  return (
    <>
      {spinnerTrans && <Transparentspinner />}
      <Breadcrumbs mainTitle="Overdue Follow-Ups" parent="Lead Manager" title="Overdue Follow-Ups List" />
      <Card className='cardWidth mt-4'>
        <CardHeader style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <H3>Overdue Follow-Ups List</H3>
          <Dropdown className='m-0' isOpen={dropdownOpen} toggle={toggleDropdown}>
            <DropdownToggle color="#fff" style={{ fontSize: '14px', zIndex: 1000 }} className="btn btn-primary mr-4">
              {Export} <i className="icofont icofont-arrow-up"></i>
            </DropdownToggle>
            <DropdownMenu container="body">
              <DropdownItem style={toggleStyle} onClick={() => exportCustomerExcel()}><i className="fa fa-file-excel-o me-2"></i> Excel</DropdownItem>
              <DropdownItem style={toggleStyle} onClick={() => exportCustomerPdf()}><i className="fa fa-file-pdf-o me-2"></i> Pdf</DropdownItem>
            </DropdownMenu>
          </Dropdown>

        </CardHeader>
        <CardBody>
          <span className=''>
            <Form className="needs-validation" noValidate onSubmit={handleFilter}>
              <Row className="ps-3 gap-sm-3 gap-md-2 mb-4 filterGap">
                <Col sm="12" md='5' lg='2'>
                  <input className="form-control"
                    onChange={(e) => { setFilters({ ...filters, search: e.target.value }) }}
                    placeholder={Search}
                    type="text"
                    value={filters.search}
                  />
                </Col>


                <Col sm="12" md="5" lg='3' className="form-element" >
                  <div style={{ position: 'relative', zIndex: 2 }}>
                    <DatePicker
                      className="form-control digits w-100"
                      selectsRange
                      startDate={startDate}
                      endDate={endDate}
                      onChange={(update) => {
                        setDateRange(update);
                      }}
                      isClearable={startDate ? true : false}
                      monthsShown={2}
                      dateFormat="dd/MM/yyyy"
                      popperPlacement="bottom"
                      calendarClassName='parallel-calendar'
                      placeholderText='Select Date Range'
                    />
                  </div>
                </Col>
                <Col sm="12" md="2">
                              <select
  value={filters.userId}
  onChange={(e) =>
    setFilters({
      ...filters,
      userId: e.target.value,
    })
  }
  className="form-control"
>
  <option value="">Assigned User</option>

  {users?.map((item) => (
    <option key={item.id} value={item.id}>
      {item.first_name}
    </option>
  ))}
</select>
                            </Col>
                
                <Col sm="12" md="5" lg='2' className="form-element" >
                  <div style={{ position: 'relative', zIndex: 2 }}>
                    <select value={filters.stage} onChange={(e) => { setFilters({ ...filters, stage: e.target.value }) }} className='form-select ' name="" id="">
                      <option value={''}> Stage</option>
                      {
                        enquiryStatusOptions?.map((item) => (
                          <option key={item?.value} value={item?.value}>{item?.label}</option>
                        ))
                      }
                    </select>

                  </div>
                </Col>
                <Col sm="12" md="5" lg='1' className="custom-filtrs">
                  <Btn attrBtn={{ color: "primary" }} type="submit">{Filter}</Btn>
                </Col>
              </Row>
            </Form>
          </span>

          <div className="order-history table-responsive">
            <DataTable
              columns={duefollowUpColumns(authState)}
              data={customerLists}
              // progressPending={loading}
              pagination
              paginationServer
              defaultSortAsc
              onSort={handleSort}
              sortServer
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              onChangeRowsPerPage={handlePerRowsChange}
            //conditionalRowStyles={conditionalRow}  
              onChangePage={handlePageChange}
              fixedHeader
            />
          </div>
        </CardBody>
      </Card>


    </>
  )
}

export default OverdueFollowUp